import { render } from "./gateways.vue?vue&type=template&id=5a929dc7"
import script from "./gateways.vue?vue&type=script&lang=js"
export * from "./gateways.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__